import template from './habit_5_report_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class Habit5ReportHelpViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog
    }

    close()
    {
        this.dialog.close()
    }
}

class Habit5ReportHelpPage
{
    constructor(bindings)
    {
        this.viewModel = new Habit5ReportHelpViewModel(this)
        this.bindings = bindings
        const tr = Utils.get_translator('default')
    }

    init()
    {
        Utils.refresh_data_visible_roles()
    }
}

export default {
    name: 'Habit5ReportHelp',
    dialog_class: Habit5ReportHelpPage,
    template: template,
    template_filename: 'translation/dialogs/eea_report_help',
    provider: 'ps',
}
